import React, { useRef } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { Box, Typography } from "@mui/material";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";

const AverageHandlingTime = ({ cardDetails }) => {
  const chartRef = useRef(null);

  const agentNames = cardDetails?.agentAverageHandlingTime?.agentFullName || [];
  const aht = cardDetails?.agentAverageHandlingTime?.averageHandlingTime || [];
  const hasData = agentNames.length > 0 && aht.length > 0;

  const secondsToTime = (sec) => {
    const h = String(Math.floor(sec / 3600)).padStart(2, "0");
    const m = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const timeStringToSeconds = (timeStr) => {
    const p = timeStr.split(":").map(Number);
    return p.length === 3
      ? p[0] * 3600 + p[1] * 60 + p[2]
      : p.length === 2
      ? p[0] * 60 + p[1]
      : Number(timeStr);
  };

  const chartValues = aht.map((t) => {
    const sec = timeStringToSeconds(t);
    return {
      value: sec,
      originalTime: t,
      itemStyle: { borderRadius: [4, 4, 0, 0] },
    };
  });

  const option = {
    title: {
      text: "Average Handling Time by Agent",
      left: "left",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    legend: { left: "right" },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) =>
        `${params[0].name}<br/>AHT: <b>${params[0].data.originalTime}</b>`,
    },
    xAxis: {
      type: "category",
      data: agentNames,
      axisLabel: { rotate: 30, fontSize: 10 },
    },
    yAxis: {
      type: "value",
      name: "Time in seconds",
      nameLocation: "middle",
      nameGap: 30,
      nameTextStyle: { fontSize: 12, padding: [0, 0, 10, 0] },
      axisLabel: { fontSize: 10 },
    },
    series: [
      {
        name: "AHT by Agent",
        type: "bar",
        data: chartValues,
        barWidth: 28,
        // 🌈 Modern Gradient Bar Color
        itemStyle: {
          borderRadius: [4, 4, 0, 0],
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#FF7043" }, // top
            { offset: 1, color: "#FFB74D" }, // bottom
          ]),
        },
        label: {
          show: true,
          position: "top",
          fontSize: 10,
          formatter: ({ value }) => secondsToTime(value),
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        height: "50vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!hasData && (
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          mb="20px"
        >
          <Typography
            fontSize={14}
            variant="body2"
            color="#464646"
            fontWeight={700}
          >
            Average Handling Time by Agent
          </Typography>
        </Box>
      )}

      {hasData ? (
        <ReactECharts
          ref={chartRef}
          option={option}
          style={{ flex: 1 }}
          opts={{ renderer: "svg" }}
        />
      ) : (
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          fontWeight={600}
          color="#999"
          borderRadius="8px"
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

export default AverageHandlingTime;